import { render, staticRenderFns } from "./FiltersPanel.vue?vue&type=template&id=06490e86&scoped=true"
import script from "./FiltersPanel.vue?vue&type=script&lang=js"
export * from "./FiltersPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06490e86",
  null
  
)

export default component.exports